import { render, staticRenderFns } from "./DialogCrud.vue?vue&type=template&id=11b2827b&"
import script from "./DialogCrud.vue?vue&type=script&lang=js&"
export * from "./DialogCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports